module.exports = __webpack_public_path__ + "public/SiteIcons/hostStepIcons/calendar.svg?d0373276";